export const logoutConfirmation = "Are you sure, you want to log out?";

export const dirtyFromConfirmation =
  "Are you sure you want to leave without saving changes? Any unsaved modifications will be lost.";

export const sessionWarningMessage =
  "Your session is about to expire due to inactivity!";

export const logoutUrl = "/api/phlebotomists-portal/logout-user/";

export const changePasswordUrl = "/api/phlebotomists-portal/change-password/";

export const verifyOtpUrl =
  "/api/phlebotomists-portal/verify-otp-phlebotomist-test/";

export const enableMFAUrl =
  "/api/phlebotomists-portal/phlebotomist-enable-mfa/";

export const phlebotomistVerifyOtpUrl =
  "/api/phlebotomists-portal/phlebotomist-verify-otp/";

export const forgotPasswordUrl =
  "/api/phlebotomists-portal/phlebotmoist-forgot-password/";

export const loginUrl = "/api/phlebotomists-portal/login-user/";

export const resetPasswordUrl =
  "/api/phlebotomists-portal/phlebotomist-reset-password";

export const searchBookingsUrl = "/api/phlebotomists-portal/search-bookings/";

export const checkClinicalPatientUrl =
  "/api/phlebotomists-portal/check-clinical-service-patient/";
export const createClinicalPatientUrl =
  "/api/phlebotomists-portal/clinical-service-register-patient/";

export const postUrlBarcode = "/api/phlebotomists-portal/validate-barcode/";

export const activateUserUrl = "/api/phlebotomists-portal/activate-user";

export const checkUserUrl =
  "/api/phlebotomists-portal/check-user/?activation_str=";

export const editUserUrl = "/api/phlebotomists-portal/edit-user/";

export const refreshTokenUrl = "/api/phlebotomists-portal/refresh-token/";
export const ssoExchangeUrl = "/api/saml/exchange/";
export const ssoLoginUrl = "/api/saml/login/";
export const ssoLogoutUrl = "/api/saml/logout/";


//region Vitality Healthchecks apis

export const VH_FLAG = "/api/phlebotomists-portal/feature-flag/";
export const storeLocation =
  "/api/phlebotomists-portal/store-location/?store_number=";
export const patientSearchApi = "/api/phlebotomists-portal/v2/bookings/";
export const storeLocatorePostApi = "/api/phlebotomists-portal/assign-store/";
export const consultationDraftUrl =
  "/api/phlebotomists-portal/consultation-draft/";
export const consultationDraftStatusUrl =
  "/api/phlebotomists-portal/draft-status/";
export const exitConsultationUrl =
"/api/phlebotomists-portal/exit-consultation/";
export const patientConsentUrl =
  "/api/phlebotomists-portal/patient-consent/";
export const resultOutcomeGet =
  "/api/phlebotomists-portal/consultation/results/";
export const consultationSubmitPost =
  "/api/phlebotomists-portal/consultation/submit/";
export const patientDetailsGet =
  "/api/phlebotomists-portal/patient-details/";
export const consultationCompletePost =
  "/api/phlebotomists-portal/consultation/complete/";
export const createtrainingphlebotomisturl =
  "/api/phlebotomists-portal/training/";
export const resettrainingphlebotomisturl =
  "/api/phlebotomists-portal/reset-training-data/"
export const RISK_PROFILE_OPTIONS = [
  { value: "normal", label: "Normal" },
  { value: "borderline", label: "Borderline" },
  { value: "elevated", label: "Elevated (non-urgent)" },
  { value: "urgent", label: "Urgent" },
];

export const LIFESTYLE_ADVICE_OPTIONS = [
  { key: "healthy_diet", label: "Healthy diet" },
  { key: "regular_physical_activity", label: "Regular physical activity" },
  { key: "weight_loss", label: "Weight loss" },
  { key: "reduced_alcohol_intake", label: "Reduced alcohol intake" },
  { key: "smoking_cessation", label: "Smoking cessation" },
];

export const OUTCOME_OPTIONS = [
  {
    key: "encourage_continuation",
    label: "Encourage continuation of current lifestyle",
  },
  {
    key: "discuss_result_gp",
    label: "Discuss result, advised to inform GP as appropriate",
  },
  {
    key: "lifestyle_advice_given",
    label: "Lifestyle advice and behaviour modification to reduce risk",
  },
  {
    key: "further_support",
    label:
      "Further support required, advised to inform GP or appropriate clinician for further investigation",
  },
  {
    key: "same_day_referral",
    label: "Same-day referral to GP/A&E or urgent care as appropriate",
  },
  { key: "other", label: "Other" },
];

export const CLASSIFICATION_MAP = {
  normal: {
    className: "classification-chip--normal",
    label: "Normal",
  },
  healthy: {
    className: "classification-chip--normal",
    label: "Healthy",
  },
  "healthy-weight": {
    className: "classification-chip--normal",
    label: "Healthy weight",
  },
  overweight: {
    className: "classification-chip--high",
    label: "Overweight",
  },
  high: {
    className: "classification-chip--high",
    label: "High",
  },
  elevated: {
    className: "classification-chip--warning",
    label: "Elevated",
  },
  increased: {
    className: "classification-chip--warning",
    label: "Increased",
  },
  low: {
    className: "classification-chip--low",
    label: "Low",
  },
  underweight: {
    className: "classification-chip--low",
    label: "Underweight",
  },
  "very-high": {
    className: "classification-chip--irregular",
    label: "Very high",
  },
  irregular: {
    className: "classification-chip--irregular",
    label: "Irregular",
  },
  "obesity-1": {
    className: "classification-chip--irregular",
    label: "Obesity Class I",
  },
  "obesity-2": {
    className: "classification-chip--irregular",
    label: "Obesity Class II",
  },
  "obesity-3": {
    className: "classification-chip--irregular",
    label: "Obesity Class III",
  },
};

export const PARAMETER_LABEL_MAP = {
  bmi: "BMI",
  waistHeightRatio: "Waist:Height Ratio",
  systolicBp: "Systolic BP",
  diastolicBp: "Diastolic BP",
  heartRate: "Heart rate",
  totalCholesterol: "Total Cholesterol",
  hdlCholesterol: "HDL Cholesterol",
  triglycerides: "Triglycerides",
  ldlCholesterol: "LDL Cholesterol",
  totalHdlRatio: "TC:HDL Ratio",
  nonHdlCholesterol: "Non-HDL Cholesterol",
  heartAge: "Heart age",
  cvdRisk: "10-year CVD risk",
  rbg: "Glucose",
};
export const clinicalMeasurementsUrl =
  "/api/phlebotomists-portal/clinical-measurements/";

//endregion

export const stepsOne = {
  Box1: (
    <span>
      Ensure the tube is securely closed and gently mix by inverting the tube{" "}
      <strong>5 times</strong>{" "}
    </span>
  ),
  Box2: `Ensure the vessel has the
correct label with the
corrrect barcode
label`,
  Box3: `Insert the sample
into the specimen
transport bag`,
  Box4: `Seal the specimen
transport bag and
 place inside the
outer box`,
  Box5: `Place the outer box
of the collection into
the return postal
bag and seal it`,
  Box6: `Store the samples in 
a refrigerator at a 
temperature 2-8  °C
until it is collected
by the courier`,
};

export const stepsTwo = {
  Box1: (
    <span>
      Ensure the tubes is securely closed and gently mix by inverting the tube{" "}
      <strong>5 times</strong>{" "}
    </span>
  ),
  Box2: `Ensure the vessels has the correct label with the correct barcode label`,
  Box3: `Insert the samples into the specimen transport bag`,
  Box4: `Seal the specimens transport bag and place inside the outer box`,
  Box5: `Place the outer box of the collection into the return postal bag and seal it`,
  Box6: `Store the samples in a refrigerator at a temperature of 2-8 °C until it is collected by the courier`,
};

export const clinicalSteps = {
  Box1: (
    <span>
      <strong>Allow the gold tube sample to clot.</strong>
      <br />
      As soon as the tube is removed from the holder,{" "}
      <strong>gently invert</strong> it 5 to 8 times (180° turn and back) to mix
      the clot activator with the blood. Do not shake vigorously as this can
      cause haemolysis. Allow the sample to clot in an upright position (not on
      its cap) at room temperature for a minimum of 20–30 minutes.
    </span>
  ),
  Box2: (
    <span>
      <strong>Prepare for centrifugation.</strong>
      <br /> For optimal sample integrity,
      <strong> begin centrifugation within one hour of</strong> venipuncture.
      Ensure the centrifuge is set using <strong>RCF (1000–1300 g)</strong>.{" "}
      <br />
      <strong>NOTE: not rpm.</strong>
    </span>
  ),
  Box3: (
    <span>
      <strong>Centrifuge the sample.</strong> <br />
      Spin for <strong>10 minutes</strong> if using a{" "}
      <strong>swinging-bucket rotor</strong>. Spin for{" "}
      <strong>15 minutes</strong> if using a <strong>fixed-angle rotor</strong>.
    </span>
  ),
  Box4: `Insert the samples into the specimen transport bag.`,
  Box5: `Seal the specimen transport bag and place inside the outer box.`,
  Box6: `Place the outer box of the collection into the return postal bag and seal it.`,
  Box7: `Store samples at ambient temperature in a cool, dry environment, protected from heat and direct sunlight, or refrigerate at 2–8 °C where available.`,
};

export const MULTI_DEVICE_LOGIN_MESSAGE =
  "You have logged in to another device";

export const trainingUserEmails = [
  "john.smith@example.com",
  "jane.carlos@example.com",
];

export const trainingClinicalWarning =
  "Please select the healthcare services for training";

export const repeatedTestMapping = {
  "Yes (payment required)": "Yes; Payment required",
  "Yes (paid)": "Yes; Already paid",
};